import React from 'react';
import { Link } from 'react-router-dom';
import { injectIntl } from 'react-intl';

class NestedLevelButton extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { username, children_count, intl } = this.props;

    if (! children_count) return null;

    const nestedLevelURL = `/${intl.locale}/account/clients?filter[parent]=${username}`;

    return (
      <div style={{marginTop: '8px'}}>
        <Link to={nestedLevelURL} class="btn-rounded m-r-10 btn btn-sm btn-default" onClick={(e) => e.stopPropagation()}>
          <i class="fa fa-folder-tree" />
        </Link>
      </div>
    );
  }
}

export default injectIntl(NestedLevelButton);
